import React from "react";

const FunFactSection = () => {
  return (
    <div>
      {/* Fun Fact Section */}
      <section className="boxcar-fun-fact-section">
        <div className="large-container">
          <div className="fact-counter">
            <div className="row">
              {/* Counter block Two*/}
              <div className="counter-block col-lg-3 col-md-3 col-sm-4 wow fadeInUp">
                <div className="inner wow fadeInUp">
                  <div className="content">
                    <div className="widget-counter">
                      <span
                        className="count-text"
                        data-speed={3000}
                        data-stop={200}
                      >
                        0
                      </span>
                      +
                    </div>
                    <h6 className="counter-title">Happy Customers</h6>
                  </div>
                </div>
              </div>
              {/* Counter block Two*/}
              <div
                className="counter-block col-lg-3 col-md-3 col-sm-4 wow fadeInUp"
                data-wow-delay="300ms"
              >
                <div className="inner wow fadeInUp" data-wow-delay="100ms">
                  <div className="content">
                    <div className="widget-counter">
                      <span
                        className="count-text"
                        data-speed={3000}
                        data-stop={200}
                      >
                        0
                      </span>
                      +
                    </div>
                    <h6 className="counter-title">Cars Sold</h6>
                  </div>
                </div>
              </div>
              {/* Counter block Two*/}
              <div
                className="counter-block col-lg-3 col-md-3 col-sm-4 wow fadeInUp"
                data-wow-delay="600ms"
              >
                <div className="inner wow fadeInUp" data-wow-delay="200ms">
                  <div className="content">
                    <div className="widget-counter">
                      <span
                        className="count-text"
                        data-speed={3000}
                        data-stop={90}
                      >
                        0
                      </span>
                      +
                    </div>
                    <h6 className="counter-title">VISITORS PER DAY</h6>
                  </div>
                </div>
              </div>
              {/* Counter block Two*/}
              <div
                className="counter-block col-lg-3 col-md-3 col-sm-4 wow fadeInUp"
                data-wow-delay="900ms"
              >
                <div className="inner wow fadeInUp" data-wow-delay="300ms">
                  <div className="content">
                    <div className="widget-counter">
                      <span
                        className="count-text"
                        data-speed={3000}
                        data-stop={236}
                      >
                        0
                      </span>
                      +
                    </div>
                    <h6 className="counter-title">SUCCESSFUL DELIVERIES</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Fun Fact Section*/}
    </div>
  );
};

export default FunFactSection;
